import { Badge, Flex, Tooltip } from "antd";
import { ReactComponent as Camera } from "../../../assets/images/Camera.svg";
import { ReactComponent as ReportIcon } from "../../../assets/images/Report.svg";
import { ReactComponent as ShipIcon } from "../../../assets/images/boat_icon.svg";
import { PrematchedFoundItems } from "../../../types/PreMatchedFoundItems";
import { convertUtcToLocal } from "../../../utils/helpers/convertUtcToLocal";
import {
    AssigneeName,
    InfoText,
    LocationContainer,
    MatchFoundBtnWrapper,
    MatchFoundHeader,
    MatchFoundHeaderLeftContainer,
    MatchFoundHeaderLeftSub,
    MatchFoundInfo,
    MatchFoundInfoText,
    MatchFoundItemWrapper,
    MatchFoundReportDateMainContainer,
    MatchFoundReportDateWrapper,
    MatchFoundSubCategoryTitle,
    MatchFoundSubTitle,
    MatchFoundTicketWrapper,
    MatchFoundTitle,
    MatchFoundTitleReportId,
    ScoreContainer,
    ShipWrapper,
} from "./styles";
import { EnvironmentOutlined } from "@ant-design/icons";
import { FoundItemCardType, FoundItemTypeOptions } from "../../../types/FoundItemTypes";
import { ReactComponent as LuggageIcon } from "../../../assets/images/travel_luggage_and_bags.svg";
import { capitalizeFirstLetter } from "../../../utils/helpers/capitalizeFirstLetter";

interface PreMatchFoundItemCardProps {
    selectedItem: PrematchedFoundItems | null;
    item: PrematchedFoundItems;
    cardType?: FoundItemCardType;
    status?: string;
    isModal?: boolean;
    handleItemClick: () => void;
}
const PreMatchFoundItemCard = ({ selectedItem, item, cardType, status, isModal, handleItemClick }: PreMatchFoundItemCardProps) => {
    const getColorByPercentage = (percentage: number): string => {
        if (percentage >= 80 && percentage <= 100) {
            return "#73D13D"; // green-5
        } else if (percentage >= 50 && percentage < 80) {
            return "#FFC53D"; // gold-5
        } else {
            return "#FF4D4F"; // red-5
        }
    };

    const getColorByPercentageForLight = (percentage: number): string => {
        if (percentage >= 80 && percentage <= 100) {
            return "#f3ffec"; // green-5
        } else if (percentage >= 50 && percentage < 80) {
            return "#fefaef"; // gold-5
        } else {
            return "#fff2f0"; // red-5
        }
    };

    const scoreBgColor = item?.score ? getColorByPercentage(item?.score) : "";
    return (
        <MatchFoundItemWrapper onClick={() => handleItemClick()}>
            {/* <Badge.Ribbon text="Final matched" color="green" placement="end" style={{ top: "57%" }}> */}
            <MatchFoundTicketWrapper isModal={isModal} status={status} cardType={cardType} scoreColor={scoreBgColor} bgColor={getColorByPercentageForLight(item?.score)} className={selectedItem?.id === item?.id && cardType !== FoundItemCardType.Matched ? "selected" : isModal ? "unSelected" : ""}>
                <MatchFoundHeader>
                    <MatchFoundHeaderLeftContainer>
                        <MatchFoundHeaderLeftSub>
                            <ReportIcon />
                            <MatchFoundTitleReportId>{item?.itemNumber || "-"}</MatchFoundTitleReportId>
                            {item?.documents?.length > 0 && <Camera />}
                        </MatchFoundHeaderLeftSub>
                        <ScoreContainer>
                            {item?.foundType === FoundItemTypeOptions.FoundLuggage && <LuggageIcon />}
                            {item?.score > 0 && <MatchFoundBtnWrapper bgColor={scoreBgColor ?? "#fff"}>{(item?.score && `${item?.score?.toFixed(2)}%`) || "-"}</MatchFoundBtnWrapper>}
                        </ScoreContainer>
                    </MatchFoundHeaderLeftContainer>
                </MatchFoundHeader>
                <Tooltip placement="topLeft" title={(item?.category?.name || "") + " - " + (item?.subCategory?.name || "")}><MatchFoundTitle>{(item?.category?.name || "")}<MatchFoundSubCategoryTitle>{" - " + (item?.subCategory?.name || "")}</MatchFoundSubCategoryTitle></MatchFoundTitle></Tooltip>
                <MatchFoundSubTitle>
                    <LocationContainer>
                        <EnvironmentOutlined />
                        <MatchFoundInfoText>{item?.location?.name}</MatchFoundInfoText>
                    </LocationContainer>
                    {item?.caseManager?.firstName && <AssigneeName>{capitalizeFirstLetter(item?.caseManager?.firstName)}</AssigneeName>}
                </MatchFoundSubTitle>
                <Flex justify="space-between" align="center" gap={4} >
                    <MatchFoundReportDateMainContainer>
                        <MatchFoundReportDateWrapper>
                            <MatchFoundInfo>Found:</MatchFoundInfo>
                            <MatchFoundInfoText>{item?.foundDate && convertUtcToLocal(item?.foundDate, "MM/DD/YYYY")}</MatchFoundInfoText>
                        </MatchFoundReportDateWrapper>
                    </MatchFoundReportDateMainContainer>
                    {item?.ship?.name && <ShipWrapper>
                        {<ShipIcon />} <InfoText>{item?.ship?.name}</InfoText>
                    </ShipWrapper>}
                </Flex>
            </MatchFoundTicketWrapper>
            {/* </Badge.Ribbon> */}

        </MatchFoundItemWrapper>
    );
};

export default PreMatchFoundItemCard;
